import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-decoration-angle-right-top",
  "use": "icon-decoration-angle-right-top-usage",
  "viewBox": "0 0 20 19",
  "content": "<symbol viewBox=\"0 0 20 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-decoration-angle-right-top\">\r\n<line x1=\"1\" y1=\"16\" x2=\"1\" y2=\"-2.18557e-08\" stroke=\"white\" />\r\n<line x1=\"1.5\" y1=\"18.5\" x2=\"19.5\" y2=\"18.5\" stroke=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol